<template>
  <v-row>
    <v-col cols="12" class="text-center">
      <v-img :src="imageUrl" contain max-width="300" max-height="350" class="ma-auto"></v-img>
      <a :href="imageUrl" target="_blank">View Full (Size: {{ size }})</a>
    </v-col>
    <v-col cols="12" md="8" offset-md="2" class="pb-0">
      <v-textarea outlined
                  hide-details
                  class="mb-3"
                  label="Your Affiliate Code"
                  readonly
                  rows="3"
                  :value="code"></v-textarea>
      <v-select outlined dense label="Campaign Code" v-model="campaign" :items="campaigns"></v-select>
    </v-col>
    <v-col cols="12" class="pt-0">
      <hr />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
    affiliate: {
      type: String,
      required: true,
    },
    campaigns: {
      type: Array,
      required: true
    },
  },
  data () {
    return {
      campaign: 'default'
    }
  },
  computed: {
    code () {
      return `<a href="https://www.greengeeks.com/track/${this.affiliate}/cp-${this.campaign}" target="_top">` +
        `<img border="0" src="${this.imageUrl}"></a>`
    },
  },
}
</script>
